import React from "react";
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import TeamDetails from '../../components/admincomponents/TeamDetails';

function ViewTeam({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <TeamDetails />            
    </>
  );
}

export default ViewTeam;
